import {
  AppBar,
  Grid,
  Toolbar,
  Typography,
  Avatar,
  makeStyles,
  Box,
  Button,
  Link,
  Select,
  IconButton,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import KenLoader from '../../../../Components/KenLoader';
import { useHistory, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

//Icon
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import SchoolIcon from '@material-ui/icons/School';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import {
  getpdfdata,
  getQuestionPaperData,
  postPdfQuestionPaperData,
  postQuestionPaperData,
  createQuiz,
  getquestionpaper,
  postapiquestionpaper,
} from '../../../../Utils/apiServices';

import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import routes from '../../../../Utils/routes.json';
import NativeSelect from '@material-ui/core/NativeSelect';
import KenCard from '../../../../global_components/KenCard';
import KenSelect from '../../../../global_components/KenSelect';
import KenInputField from '../../../../global_components/KenInputField';
import { ThreeDots } from 'react-loader-spinner';
import KenSmallLoader from '../../../../global_components/KenSmallLoader';
import KenSelectWrap from '../../../../global_components/KenSelect';
import KenButton from '../../../../global_components/KenButton';

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  header1: {
    background: 'transparent',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  publishGenerate: {
    background: 'orange',
    borderRadius: '25px',
    fontSize: '15px',
    margin: '5px  5px',
    color: 'white',
    '&:hover': {
      color: 'white',
      background: 'orange',
    },
  },
  normal: {
    color: 'white',

    background: 'green',

    borderRadius: '20px',
    fontSize: '15px',

    margin: '5px 5px',
    '&:hover': {
      background: 'green',

      color: 'white',
    },
  },
  TitleBox: {
    display: 'flex',
    float: 'left',
    margin: '25px 10px',
    padding: '10px',
    background: '#fff',
  },
  TitleTextSpan: {
    fontSize: '16px',
    fontWeight: 'bolder',
    marginLeft: '10px',
  },
  TitleText: {
    fontSize: '10px',
    paddingLeft: '10px',
  },
}));

const status = [
  { label: 'Current Exam', value: 'Current Exam' },
  { label: 'Re-Test Exam', value: 'Re-Test Exam' },
];

const ViewQuestionPaper = () => {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  console.log('ididdddd', id);
  const [questionData, setquestionData] = useState([]);

  const getQuestionPaperDatas = () => {
    let filterData = {
      course: '',
      status: '',
      term: '',
      faculty: '',
      batch: '',
      examCycle: '',
    };
    setLoading(true);
    getQuestionPaperData(filterData).then((res) => {
      setLoading(false);

      const QuestionPaperInfo =
        res.questionPapersList === null
          ? []
          : res.questionPapersList.map((item, index) => {
              if (id === item.id) {
                return {
                  id: item.id,
                  courseName: item.courseName ? item.courseName : 'NA',
                  term: item.term ? item.term : 'NA',
                  faculty: item.faculty ? item.faculty : 'NA',
                  status: item.status ? item.status : '',
                  facultyEmail: item.facultyEmail ? item.facultyEmail : '',
                  setOneStatus: item.setOneStatus ? item.setOneStatus : '',
                  setTwoStatus: item.setTwoStatus ? item.setTwoStatus : '',
                  paper1: item.paper1 ? item.paper1 : '',
                  paper2: item.paper2 ? item.paper2 : '',
                  Qp1url: item.Qp1url ? item.Qp1url : '',
                  Qp2url: item.Qp2url ? item.Qp2url : '',
                  status: item.status ? item.status : '',
                };
              }
            });

      const filterData = QuestionPaperInfo.filter((e) => {
        return e != undefined;
      });

      setquestionData(filterData);

      // setFilterDialog(false);
    });
  };
  const [loading, setLoading] = useState(false);
  const [urlPdf, setUrlPdf] = useState();
  const [openMsgCard, setOpenMsgCard] = useState(false);
  const [openMsgCard1, setOpenMsgCard1] = useState(false);
  const [remindeText1, setRemindeText1] = useState('');
  const [remindeText2, setRemindeText2] = useState('');
  const [isQPStatueEdit2, setIsQPStatueEdit2] = useState(false);
  const [isQPStatueEdit1, setIsQPStatueEdit1] = useState(false);

  const [options, setOptions] = useState([]);

  const [qp1Status, setQp1Status] = useState('');
  const [qp2Status, setQp2Status] = useState('');

  const [selectedOption, setSelectedOption] = useState('');
  const [selectedOption1, setSelectedOption1] = useState('');
  let ab = useParams();
  const getData = () => {
    getquestionpaper(id)
      .then((data) => {
        setOptions(data?.questionPapersList?.[0]);
      })

      .catch((error) => console.error(error));
  };
  const handleSelectChange = (event) => {
    const payload = [
      {
        id: id,
        status: 'Request Sent',
        QuestionPaperSet1: qp1Status,
        sendEmail: false,
      },
    ];
    postapiquestionpaper(payload)
      .then((data) => getQuestionPaperDatas())
      .catch((error) => console.error(error));
  };

  const handleSelectChange1 = (event) => {
    const payload = [
      {
        id: id,
        status: 'Request Sent',
        QuestionPaperSet2: qp2Status,
        sendEmail: false,
      },
    ];
    postapiquestionpaper(payload)
      .then((data) => getQuestionPaperDatas())
      .catch((error) => console.error(error));
  };
  const [state, setState] = React.useState({
    age: '',
    name: 'hai',
  });

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };
  const onMsgopen = () => {
    setOpenMsgCard((prev) => !prev);
  };
  const onMsgopen1 = () => {
    setOpenMsgCard1((prev) => !prev);
  };
  const onChangeOfReminder = (e) => {
    setRemindeText2(e.target.value);
  };
  const onChangeOfReminder1 = (e) => {
    setRemindeText1(e.target.value);
  };
  const getAPI = async () => {
    setLoading(true);

    let questionPaperId = id;

    // let ab = await getpdfdata(questionPaperId);

    let ab = await createQuiz(questionPaperId).then((res) => {
      if (res.message == "The course ID doesn't exist.") {
        return {
          questionPaperSet1: `https://www.flame.edu.in/pdfs/ug_sample_paper.pdf`,
          questionPaperSet2: `https://www.flame.edu.in/pdfs/ug_sample_paper.pdf`,
        };
      }

      if (res.questionpaper) {
        return {
          questionPaperSet1: `https://www.flame.edu.in/pdfs/ug_sample_paper.pdf`,
          questionPaperSet2: `https://www.flame.edu.in/pdfs/ug_sample_paper.pdf`,
        };
      }
    });
    setUrlPdf(ab);

    // return ab;
    setLoading(false);
  };

  console.log(
    'options?.questionPapersListoptions?.questionPapersList',
    options.paper1
  );
  // const str = getAPI();
  const blo = async () => {
    setLoading(true);

    const str = await getAPI();

    // const blob = new Blob([str], { type: 'application/pdf' });
    // const blobUrl = URL.createObjectURL(blob);
    setUrlPdf(str);
    setLoading(false);
  };
  const handleClickOnView = () => {
    history.push(`${routes.questionPaper}`);
  };
  const onQuestionPaperSet1Approve = () => {
    const payload = [
      {
        questionPaperId: id,
        questionPaperStatus: 'Approved',
        questionPaperSet: 1,
      },
    ];
    postPdfQuestionPaperData(payload)
      .then((res) => {
        // getAPI();
      })
      .catch((err) => {
        console.log('Failed to add. Please try again.', err);
      });
  };

  const onQuestionPaperSet2Approve = () => {
    const payload = [
      {
        questionPaperId: id,
        questionPaperStatus: 'Approved',
        questionPaperSet: 2,
      },
    ];
    postPdfQuestionPaperData(payload)
      .then((res) => {
        // getAPI();
      })
      .catch((err) => {
        console.log('Failed to add. Please try again.', err);
      });
  };

  const onQuestionPaperRemide = () => {
    const payload = [
      {
        sendEmail: true,
        subject: 'Test Subj',
        body: remindeText2,
        // toAddresses: `test@345.com`,
        toAddresses: `${questionData[0].facultyEmail}`,
      },
    ];
    postQuestionPaperData(payload)
      .then((res) => {
        toast.success('Mail Sent Successfully', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        getQuestionPaperDatas();
      })
      .catch((err) => {
        console.log('Failed to add. Please try again.', err);
      });

    setOpenMsgCard(false);
    setOpenMsgCard1(false);
  };
  useEffect(() => {
    setLoading(true);

    getQuestionPaperDatas();
    getAPI();
    getData();
    // blo();
    setLoading(false);
  }, []);

  return (
    <Box>
      {loading && <KenLoader />}
      <ToastContainer />

      {/* <Box className={classes.breadCrumbWrapper}>
        <BreadCrumb array={arrayBreadCrumb} history={history} />
      </Box> */}
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            QUESTION PAPER VIEW
          </Typography>
          <div>
            <KenButton
              style={{ marginRight: '10px' }}
              variant="contained"
              onClick={() => history.goBack()}
            >
              Back
            </KenButton>
            <KenButton variant="contained">Save</KenButton>
          </div>
        </Toolbar>
      </AppBar>
      <AppBar position="static" elevation={0} className={classes.header1}>
        <Grid xs={12} style={{ display: 'flex', float: 'left' }}>
          <Grid item xs={4} className={classes.TitleBox}>
            <Avatar
              sx={{ bgcolor: 'red' }}
              style={{ backgroundColor: 'transparent' }}
              QUESTION
              PAPER
              VIEW
              aria-label="recipe"
            >
              <AssignmentIcon style={{ color: '##272727' }} />
            </Avatar>
            <div>
              {' '}
              <div className={classes.TitleTextSpan}>
                {questionData[0] === undefined ? (
                  <KenSmallLoader />
                ) : (
                  questionData[0].courseName
                )}
              </div>
              <div className={classes.TitleText}>COURSE NAME</div>
            </div>
          </Grid>
          <Grid item xs={3} className={classes.TitleBox}>
            <Avatar
              sx={{ bgcolor: 'red' }}
              style={{ backgroundColor: 'transparent' }}
              aria-label="recipe"
            >
              <SchoolIcon style={{ color: '##272727' }} />
            </Avatar>
            <div>
              <div className={classes.TitleTextSpan}>
                {' '}
                {questionData[0] === undefined ? (
                  <KenSmallLoader />
                ) : (
                  questionData[0].term
                )}{' '}
              </div>
              <div className={classes.TitleText}> TERM </div>
            </div>
          </Grid>
          <Grid item xs={2} className={classes.TitleBox}>
            <Avatar
              sx={{ bgcolor: 'red' }}
              style={{ backgroundColor: 'transparent' }}
              aria-label="recipe"
            >
              <AssignmentIndIcon style={{ color: '##272727' }} />
            </Avatar>
            <div>
              {' '}
              <div className={classes.TitleTextSpan}>
                {questionData[0] === undefined ? (
                  <KenSmallLoader />
                ) : (
                  questionData[0].faculty
                )}{' '}
              </div>
              <div className={classes.TitleText}> FACULTY </div>
            </div>
          </Grid>
          <Grid item xs={2} className={classes.TitleBox}>
            <Avatar
              sx={{ bgcolor: 'red' }}
              style={{ backgroundColor: 'transparent' }}
              aria-label="recipe"
            >
              <AssignmentTurnedInIcon style={{ color: '##272727' }} />
            </Avatar>
            <div>
              {' '}
              <div className={classes.TitleTextSpan}>
                {' '}
                {questionData[0] === undefined ? (
                  <KenSmallLoader />
                ) : questionData[0].setOneStatus === 'Approved' ? (
                  'Approved'
                ) : (
                  'Not Approved'
                )}
              </div>
              <div className={classes.TitleText}> QUESTION PAPER-1 STATUS </div>
            </div>
          </Grid>
          <Grid item xs={2} className={classes.TitleBox}>
            <Avatar
              sx={{ bgcolor: 'red' }}
              style={{ backgroundColor: 'transparent' }}
              aria-label="recipe"
            >
              <AssignmentTurnedInIcon style={{ color: '##272727' }} />
            </Avatar>
            <div>
              {' '}
              <div className={classes.TitleTextSpan}>
                {' '}
                {questionData[0] === undefined ? (
                  <KenSmallLoader />
                ) : questionData[0].setTwoStatus === 'Approved' ? (
                  'Approved'
                ) : (
                  'Not Approved'
                )}
              </div>
              <div className={classes.TitleText}> QUESTION PAPER-2 STATUS </div>
            </div>
          </Grid>
        </Grid>
      </AppBar>

      <div style={{ marginBottom: '50px' }}>
        <div
          style={{
            display: 'flex',
          }}
        >
          <div
            style={{
              width: '48%',
              marginRight: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px',
              }}
            >
              <div
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  marginRight: '34%',
                }}
              >
                Question Paper set 1
              </div>
              <div style={{ marginRight: '5px' }}>
                {/* <FormControl variant="filled" className={classes.formControl}>
                  <select
                    style={{
                      width: '180px',
                      height: '30px',
                      cursor: 'pointer',
                      backgroundColor: 'white',
                      border: 'none',
                    }}
                    value={selectedOption}
                    onChange={handleSelectChange}
                  >
                    <option>
                      {options?.questionPapersList?.[0]?.paper1}
                      {options?.questionPapersList?.[0]?.paper2}
                    </option>
                  </select>
                </FormControl> */}

                {questionData[0] === undefined ? (
                  <KenSmallLoader />
                ) : (
                  <>
                    {questionData[0]?.paper1 !== null && !isQPStatueEdit1 ? (
                      <KenSelect
                        optionalLabel={false}
                        disabled
                        name="Question Paper Status"
                        options={status}
                        value={questionData[0]?.paper1}
                        defaultValue={questionData[0]?.paper1}
                        style={{
                          width: '180px',
                          height: '30px',
                          cursor: 'pointer',
                          backgroundColor: 'white',
                          border: 'none',
                        }}
                      />
                    ) : (
                      <KenSelect
                        optionalLabel={false}
                        // disabled
                        name="Question Paper Status"
                        options={status}
                        value={qp1Status}
                        onChange={(e) => {
                          setQp1Status(e.target.value);
                          // SetIntercandidateSpacing(parseInt(e.target.value));
                        }}
                        defaultValue={options?.paper1}
                        style={{
                          width: '180px',
                          height: '30px',
                          cursor: 'pointer',
                          backgroundColor: 'white',
                          border: 'none',
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <div>
                {!isQPStatueEdit1 ? (
                  <IconButton
                    onClick={() => {
                      setIsQPStatueEdit1(true);
                    }}
                  >
                    <EditIcon></EditIcon>
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={() => {
                      handleSelectChange();
                      setIsQPStatueEdit1(false);
                    }}
                  >
                    <CheckIcon></CheckIcon>
                  </IconButton>
                )}
              </div>
            </div>
            {urlPdf?.questionPaperSet1 == undefined && <KenLoader />}
            {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js"> */}
            {urlPdf?.questionPaperSet1 !== undefined &&
            urlPdf?.questionPaperSet1 !== 'question paper is not availble' ? (
              <object
                // data={`data:application/pdf;base64,${urlPdf.questionPaperSet1.versionData}`}
                data={`${urlPdf.questionPaperSet1}`}
                // data={`https://www.flame.edu.in/pdfs/ug_sample_paper.pdf`}
                type="application/pdf"
                width="100%"
                height="500px"
              />
            ) : (
              <div
                style={{
                  alignItems: 'center',
                  border: '2px dashed rgba(0, 0, 0, .3)',
                  display: 'flex',
                  fontSize: '2rem',
                  height: '100%',
                  justifyContent: 'center',
                  width: '100%',
                  height: '500px',
                }}
              >
                Question paper is not available
              </div>
            )}

            {urlPdf?.questionPaperSet1 !== undefined ? (
              <div>
                {' '}
                {questionData[0] === undefined ? (
                  ''
                ) : questionData[0]?.setOneStatus === 'Approved' ? (
                  <Grid container xs={12}>
                    <Grid xs={6}>
                      {' '}
                      <Button
                        variant="primary"
                        // className="col-btn-remide"
                        // component={Link}
                        onClick={onMsgopen}
                        className={classes.publishGenerate}
                        // // to={`${routes.currentProgrammes}/${id}/details`}
                      >
                        Remind
                      </Button>
                    </Grid>
                    {/* <Grid xs={6}>
                      {' '}
                      <Button
                        variant="primary"
                        // className="col-btn-remide"
                        // component={Link}
                        // onClick={onQuestionPaperRemide}

                        className={classes.normal}
                      >
                        <Link
                          className={classes.normal}
                          href="https://dev-portal.ken42.com/questionsCreation"
                          target="_blank"
                          variant="body2"
                        >
                          Edit Que Paper
                        </Link>
                      </Button>
                    </Grid> */}
                  </Grid>
                ) : (
                  <>
                    {' '}
                    <Grid container xs={12}>
                      <Grid xs={4}>
                        {' '}
                        <Button
                          variant="primary"
                          className={classes.normal}
                          onClick={onQuestionPaperSet1Approve}
                          // component={Link}
                          // className={classOfBtn}
                          // to={`${routes.seatingPlan}/arrangement/${id}`}
                        >
                          Approve
                        </Button>
                      </Grid>
                      <Grid xs={4}>
                        {' '}
                        <Button
                          variant="primary"
                          // className="col-btn-remide"
                          // component={Link}
                          onClick={onMsgopen}
                          className={classes.publishGenerate}
                          // // to={`${routes.currentProgrammes}/${id}/details`}
                        >
                          Remind
                        </Button>
                      </Grid>
                      {/* <Grid xs={4}>
                        {' '}
                        <Button
                          variant="primary"
                          // className="col-btn-remide"
                          // component={Link}
                          // onClick={onQuestionPaperRemide}

                          className={classes.normal}
                        >
                          <Link
                            className={classes.normal}
                            href="https://dev-portal.ken42.com/questionsCreation"
                            target="_blank"
                            variant="body2"
                          >
                            Edit Que Paper
                          </Link>
                        </Button>
                      </Grid> */}
                    </Grid>
                  </>
                )}
              </div>
            ) : (
              <div className="col-12">
                <Button
                  variant="primary"
                  // className="col-btn-remide"
                  // component={Link}
                  onClick={onMsgopen}
                  className={classes.publishGenerate}
                  // // to={`${routes.currentProgrammes}/${id}/details`}
                >
                  Remind
                </Button>
              </div>
            )}
            {openMsgCard && (
              <KenCard>
                <Typography variant="h6">Send Reminder</Typography>
                <span>Sent to:{questionData[0].facultyEmail}</span>
                <KenInputField
                  name="standard"
                  label={false}
                  optionalLabel={false}
                  // rows={4}
                  // multiline={true}
                  value={remindeText2}
                  onChange={(e) => onChangeOfReminder(e)}
                  style={{ fontSize: 12, marginRight: '10px' }}
                />{' '}
                <Button
                  variant="primary"
                  // className="col-btn-remide"
                  // component={Link}
                  onClick={onQuestionPaperRemide}
                  className={classes.publishGenerate}
                  // // to={`${routes.currentProgrammes}/${id}/details`}
                >
                  Send
                </Button>
              </KenCard>
            )}
          </div>

          <div
            style={{
              width: '48%',
              marginRight: '10px',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px',
              }}
            >
              <div
                style={{
                  fontSize: '14px',
                  fontWeight: 600,
                  marginRight: '34%',
                }}
              >
                Question Paper set 2
              </div>
              <div>
                {questionData[0] === undefined ? (
                  <KenSmallLoader />
                ) : (
                  <>
                    {questionData[0]?.paper2 !== null && !isQPStatueEdit2 ? (
                      <KenSelect
                        optionalLabel={false}
                        disabled
                        name="Question Paper Status"
                        options={status}
                        value={questionData[0]?.paper2}
                        defaultValue={questionData[0]?.paper2}
                        style={{
                          width: '180px',
                          height: '30px',
                          cursor: 'pointer',
                          backgroundColor: 'white',
                          border: 'none',
                        }}
                      />
                    ) : (
                      <KenSelect
                        optionalLabel={false}
                        // disabled
                        name="Question Paper Status"
                        options={status}
                        value={qp2Status}
                        onChange={(e) => {
                          setQp2Status(e.target.value);
                          // SetIntercandidateSpacing(parseInt(e.target.value));
                        }}
                        defaultValue={options?.paper2}
                        style={{
                          width: '180px',
                          height: '30px',
                          cursor: 'pointer',
                          backgroundColor: 'white',
                          border: 'none',
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <div>
                {!isQPStatueEdit2 ? (
                  <IconButton
                    onClick={() => {
                      setIsQPStatueEdit2(true);
                    }}
                  >
                    <EditIcon></EditIcon>
                  </IconButton>
                ) : (
                  <IconButton
                    onClick={() => {
                      handleSelectChange1();
                      setIsQPStatueEdit2(false);
                    }}
                  >
                    <CheckIcon></CheckIcon>
                  </IconButton>
                )}
              </div>
            </div>
            {urlPdf?.questionPaperSet2 == undefined && <KenLoader />}
            {/* <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js"> */}
            {urlPdf?.questionPaperSet2 !== undefined &&
            urlPdf?.questionPaperSet2 !== 'question paper is not availble' ? (
              <object
                // data={`data:application/pdf;base64,${urlPdf.questionPaperSet2.versionData}`}
                data={`${urlPdf.questionPaperSet2}`}
                type="application/pdf"
                width="100%"
                height="500px"
              />
            ) : (
              <div
                style={{
                  alignItems: 'center',
                  border: '2px dashed rgba(0, 0, 0, .3)',
                  display: 'flex',
                  fontSize: '2rem',
                  height: '100%',
                  justifyContent: 'center',
                  width: '100%',
                  height: '500px',
                }}
              >
                Question paper is not available{' '}
              </div>
            )}
            {/* <Viewer
        fileUrl={
          urlPdf
            ? urlPdf
            : 'blob:http://localhost:3000/56e9c859-09d8-43cf-a4b2-7cdab8704d0f'
        }
        plugins={[defaultLayoutPluginInstance]}
      /> */}
            {/* </Worker> */}
            {urlPdf?.questionPaperSet2 !== undefined ? (
              <div>
                {questionData[0] === undefined ? (
                  ''
                ) : questionData[0].setTwoStatus === 'Approved' ? (
                  <>
                    {' '}
                    <Grid container xs={12}>
                      <Grid xs={6}>
                        {' '}
                        <Button
                          variant="primary"
                          // className="col-btn-remide"
                          // component={Link}
                          onClick={onMsgopen1}
                          className={classes.publishGenerate}
                          // // to={`${routes.currentProgrammes}/${id}/details`}
                        >
                          Remind
                        </Button>
                      </Grid>
                      {/* <Grid xs={6}>
                        {' '}
                        <Button
                          variant="primary"
                          // className="col-btn-remide"
                          // component={Link}
                          // onClick={onQuestionPaperRemide}

                          className={classes.normal}
                        >
                          <Link
                            className={classes.normal}
                            href="https://dev-portal.ken42.com/questionsCreation"
                            target="_blank"
                            variant="body2"
                          >
                            Edit Que Paper
                          </Link>
                        </Button>
                      </Grid> */}
                    </Grid>
                  </>
                ) : (
                  <>
                    {' '}
                    <Grid container xs={12}>
                      <Grid xs={4}>
                        {' '}
                        <Button
                          variant="primary"
                          className={classes.normal}
                          onClick={onQuestionPaperSet2Approve}
                          // component={Link}
                          // className={classOfBtn}
                          // to={`${routes.seatingPlan}/arrangement/${id}`}
                        >
                          Approve
                        </Button>
                      </Grid>
                      <Grid xs={4}>
                        {' '}
                        <Button
                          variant="primary"
                          // className="col-btn-remide"
                          // component={Link}
                          onClick={onMsgopen1}
                          className={classes.publishGenerate}
                          // // to={`${routes.currentProgrammes}/${id}/details`}
                        >
                          Remind
                        </Button>
                      </Grid>
                      {/* <Grid xs={4}>
                        {' '}
                        <Button
                          variant="primary"
                          // className="col-btn-remide"
                          // component={Link}
                          // onClick={onQuestionPaperRemide}

                          className={classes.normal}
                        >
                          <Link
                            className={classes.normal}
                            href="https://dev-portal.ken42.com/questionsCreation"
                            target="_blank"
                            variant="body2"
                          >
                            Edit Que Paper
                          </Link>
                        </Button>
                      </Grid> */}
                    </Grid>
                  </>
                )}
              </div>
            ) : (
              <div className="col-12">
                <Button
                  variant="primary"
                  // className="col-btn-remide"
                  // component={Link}
                  onClick={onMsgopen1}
                  className={classes.publishGenerate}
                  // // to={`${routes.currentProgrammes}/${id}/details`}
                >
                  Remind
                </Button>
              </div>
            )}{' '}
            {openMsgCard1 && (
              <KenCard>
                <Typography variant="h6">Send Reminder</Typography>
                <span>Sent to:{questionData[0].facultyEmail}</span>
                <KenInputField
                  name="standard"
                  label={false}
                  optionalLabel={false}
                  // rows={4}
                  // multiline={true}
                  value={remindeText1}
                  onChange={(e) => onChangeOfReminder1(e)}
                  style={{ fontSize: 12, marginRight: '10px' }}
                />{' '}
                <Button
                  variant="primary"
                  // className="col-btn-remide"
                  // component={Link}
                  onClick={onQuestionPaperRemide}
                  className={classes.publishGenerate}
                  // // to={`${routes.currentProgrammes}/${id}/details`}
                >
                  Send
                </Button>
              </KenCard>
            )}
          </div>
        </div>
        <div></div>
      </div>
      {/* <div>button</div> */}
    </Box>
  );
};

export default ViewQuestionPaper;
